import _ from "lodash";
import moment from "moment";

const _states = [
    {
        name: "mentalCapacity",
        display: "Mental Capacit",
        number: 1,
        nextEnabled: false
    },
    {
        name: "detailsAndRationale",
        display: "Details & rationale",
        number: 2,
        nextEnabled: false
    },
    {
        name: "discussion",
        display: "Discussion",
        number: 3,
        nextEnabled: false
    },
    {
        name: "implantableCardioverter",
        display: "Implantable Cardioverter",
        number: 4,
        nextEnabled: false
    }
]

export class DNACPROrderStatus {
    static #_avaiting = 0;
    static #_active = 1;
    static #_canceled = 2;

    static get AVAITING() { return this.#_avaiting; }
    static get ACTIVE() { return this.#_active; }
    static get CANCELED() { return this.#_canceled; }

}

export class DNACPRData {
    static getStates() {
        let stepsArr = [];
        _.orderBy(_states, ['number'], ['asc']).forEach((s) => {
            stepsArr.push(s.display);
        })
        return stepsArr;
    }

    static getFormBaseData() {
        return {
            mentalCapacity: {
                q0value: null,
                q1value: null,
                q2value: null,
                q3value: null,
                q4value: null,
                q5value: null,
                q6value: null,
                q7value: null,
                l0value: ""
            },
            detailsAndRationale: {
                validUntil: moment().startOf('day').add(2, "day"),
                description: ""
            },
            discussion: {
                q0value: null,
                debaters: [],
                discussionDoctor: "",
                discussionDate: null,
                l0value: ""
            },
            implantableCardioverter: {
                q0value: null,
                q1value: null,
                deactivateDate: null,
                q2value: null
            }
        }

    }
}

export const StepsMatrix = {
    q0: {
        y: ["q1"],
        n: []
    },
    q1: {
        y: ["q2"],
        n: ["q3"]
    },
    q2: {
        y: ["q4"],
        n: ["q3"]
    },
    q3: {
        y: ["l1","q4"],
        n: ["l1", "q4"]
    },
    q4: {
        y: ["q5"],
        n: ["q5"]
    },
    q5: {
        y: ["i0", "q7"],
        n: ["q6", "i1", "l0"]
    },
    q6: {
        y: [],
        n: []
    },
    q7: {
        y: [],
        n: []
    }
}

export const MentalCapacityLabels = {
    questions: {
        q0: "Is there any reason to doubt that the patient has the mental capacity to make and communicate decisions about CPR?",
        q1: "Does the person have an impairment of the mind or brain, or is there some sort of disturbance affecting the way their mind or brain works? (It doesn’t matter whether the impairment or disturbance is temporary or permanent.)",
        q2: "Does that impairment or disturbance mean that the person is unable to make the decision about whether to be resuscitated at the time it needs to be made",
        q3: "Have you provided all possible support to enable the patient to try and participate in the decision making process? Yes/No. If yes, please explain the support you have given. If no, please explain why or consider additional support and contact the safeguarding team if you need specific advice and record here",
        q4: "Are you aware of a valid advance decision refusing CPR which is relevant to the current condition?",
        q5: "Has the patient appointed a power attorney for health to make decisions on their behalf?",
        q6: "Has a best interests decision been made involving, where practical, the wider MDT and those important to the patient?",
        q7: "Has the power of attorney for health been consulted"
    },
    infos: {
        i0: "N.B. The power of attorney for health must be consulted.",
        i1: "Please consider the need for referral to an IMCA if there is no one independent of the health and social care services, such as a family member or friend, who is able to represent the patient."
    },
    labels: {
        l0: "Please explain why in summary box below and ensure that the above involvement is undertaken as soon as possible.",
        l1: "Please explain the support you have given"
    }
}

export const DetailsAndRationaleLabels = {
    infos: {
        i0: "DNAR orders should be communicated at every nursing hand over and to all HCPs that the patient comes into contact with.",
        i1: "Please detail :",
        i2: "1. Details of capacity assessment (if patient lacks capacity)",
        i3: "2. Rationale for the decision for DNA CPR order being undertaken",
        i4: "3. Details of discussions with MDT",
        i5: "4. Detail discussions with Patient, and anyone representing the patient such as Family/Friends/IMCA"
    },
    labels: {
        l0: "Valid until/Review Date"
    }
}

export const DiscussionLabels = {
    questions: {
        q0: "Has this been discussed with the patient and or those important to them (include welfare attorney/court appointed deputy or guardian, where appropriate)?"
    },
    infos: {
        i0: "If the patient does not have a legally appointed Health and Welfare Attorney then a decision should be made in accordance with the patient’s best interests. Please record the names and relationship to the patient of those who were consulted, including an IMCA if the patient has no next of kin.",
        i1: "Please consider the need for referral to an IMCA if there is no one independent of the health and social care services, such as a family member or friend, who is able to represent the patient"
    },
    labels: {
        l0: "Please explain why in summary box below and ensure that the above involvement is undertaken as soon as possible."
    }
}

export const ImplantableCardioverter = {
    questions: {
        q0: "Has the patient got an Implantable Cardioverter Defibrillator (ICD) in situ?",
        q1: "Has it been deactivated?",
        q2: "Has the Cheshire and Merseyside Record of Decision to Withdraw ICD Therapy in an Adult Patient been completed?"
    },
    infos: {},
    labels: {
        l0: "Date deactivated"
    }
}


